import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import PrivateRoute from './components/Auth/PrivateRoute';
import Layout from './components/Layout/Layout';
import Login from './components/Auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import UserResetPassword  from './pages/auth/ResetPassword';
import Dashboard from './pages/Dashboard';
import Profile from './pages/profile/Profile';
import Drivers from './pages/drivers/Drivers';
import DriverForm from './pages/drivers/DriverForm';
import DriverDetails from './pages/drivers/DriverDetails';
import Vehicles from './pages/vehicles/Vehicles';
import VehicleForm from './pages/vehicles/VehicleForm';
import VehicleDetails from './pages/vehicles/VehicleDetails';
import Trips from './pages/trips/Trips';
import TripForm from './pages/trips/TripForm';
import TripDetails from './pages/trips/TripDetails';
import Devices from './pages/devices/Devices';
import DeviceForm from './pages/devices/DeviceForm';
import DeviceDetails from './pages/devices/DeviceDetails';
import DeviceTypes from './pages/device-types/DeviceTypes';
import DeviceTypeForm from './pages/device-types/DeviceTypeForm';
import Events from './pages/events/Events';
import EventForm from './pages/events/EventForm';
import EventDetails from './pages/events/EventDetails';
import EventTypes from './pages/event-types/EventTypes';
import EventTypeForm from './pages/event-types/EventTypeForm';
import EventTypeDetails from './pages/event-types/EventTypeDetails';
import OrientationTypes from './pages/orientation-types/OrientationTypes';
import OrientationTypeForm from './pages/orientation-types/OrientationTypeForm';
import Users from './pages/users/Users';
import UserForm from './pages/users/UserForm';
import UserDetails from './pages/users/UserDetails';
import AdminResetPassword  from './pages/users/ResetPassword';
import ChangePassword from './pages/users/ChangePassword';
import Files from './pages/files/Files';
import FileForm from './pages/files/FileForm';
import FileDetails from './pages/files/FileDetails';
import FileTypes from './pages/file-types/FileTypes';
import FileTypeForm from './pages/file-types/FileTypeForm';
import FileTypeDetails from './pages/file-types/FileTypeDetails';
import Videos from './pages/videos/Videos';
import VideoForm from './pages/videos/VideoForm';
import VideoDetails from './pages/videos/VideoDetails';
import TripGps from './pages/trip-gps/TripGps';
import TripGpsForm from './pages/trip-gps/TripGpsForm';
import TripGpsDetails from './pages/trip-gps/TripGpsDetails';
import Statistics from './pages/statistics/Statistics';

function App() {
  return (
    <AuthProvider>
      <ThemeProvider> {/* Wrap with ThemeProvider */}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<UserResetPassword />} />

          <Route element={<PrivateRoute />}>
            <Route element={<Layout />}>
            // Inside your routes (after Layout)
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/change-password" element={<ChangePassword />} />
              
              <Route path="/drivers/filter" element={<Drivers />} />
              <Route path="/drivers/active" element={<Drivers status="active" />} />
              <Route path="/drivers/inactive" element={<Drivers status="inactive" />} />
              <Route path="/drivers/add" element={<DriverForm />} />
              <Route path="/drivers/edit/:id" element={<DriverForm />} />
              <Route path="/drivers/:id" element={<DriverDetails />} />

              <Route path="/vehicles/filter" element={<Vehicles />} />
              <Route path="/vehicles/active" element={<Vehicles status="active" />} />
              <Route path="/vehicles/inactive" element={<Vehicles status="inactive" />} />
              <Route path="/vehicles/add" element={<VehicleForm />} />
              <Route path="/vehicles/edit/:id" element={<VehicleForm />} />
              <Route path="/vehicles/:id" element={<VehicleDetails />} />

              <Route path="/trips/filter" element={<Trips />} />
              <Route path="/trips/add" element={<TripForm />} />
              <Route path="/trips/edit/:id" element={<TripForm />} />
              <Route path="/trips/:id" element={<TripDetails />} />

              <Route path="/devices/filter" element={<Devices />} />
              <Route path="/devices/active" element={<Devices status="active" />} />
              <Route path="/devices/inactive" element={<Devices status="inactive" />} />
              <Route path="/devices/add" element={<DeviceForm />} />
              <Route path="/devices/edit/:id" element={<DeviceForm />} />
              <Route path="/devices/:id" element={<DeviceDetails />} />

              <Route path="/device-types" element={<DeviceTypes />} />
              <Route path="/device-types/add" element={<DeviceTypeForm />} />
              <Route path="/device-types/edit/:id" element={<DeviceTypeForm />} />           
            
              <Route path="/events/filter" element={<Events />} />
              <Route path="/events/add" element={<EventForm />} />
              <Route path="/events/edit/:id" element={<EventForm />} />
              <Route path="/events/:id" element={<EventDetails />} />
              
              <Route path="/event-types" element={<EventTypes />} />
              <Route path="/event-types/add" element={<EventTypeForm />} />
              <Route path="/event-types/edit/:id" element={<EventTypeForm />} />
              <Route path="/event-types/:id" element={<EventTypeDetails />} />
              
              <Route path="/orientation-types" element={<OrientationTypes />} />
              <Route path="/orientation-types/add" element={<OrientationTypeForm />} />
              <Route path="/orientation-types/edit/:id" element={<OrientationTypeForm />} />
              
              <Route path="/users" element={<Users />} />
              <Route path="/users/add" element={<UserForm />} />
              <Route path="/users/edit/:id" element={<UserForm />} />
              <Route path="/users/:id" element={<UserDetails />} />
              <Route path="/users/:id/reset-password" element={<AdminResetPassword />} />
             // <Route path="/users/:id/change-password" element={<ChangePassword />} />

              <Route path="/files/filter" element={<Files />} />
              <Route path="/files/add" element={<FileForm />} />
              <Route path="/files/edit/:id" element={<FileForm />} />
              <Route path="/files/:id" element={<FileDetails />} />
              
              <Route path="/file-types" element={<FileTypes />} />
              <Route path="/file-types/add" element={<FileTypeForm />} />
              <Route path="/file-types/edit/:id" element={<FileTypeForm />} />
              <Route path="/file-types/:id" element={<FileTypeDetails />} />
              
              <Route path="/videos/filter" element={<Videos />} />
              <Route path="/videos/add" element={<VideoForm />} />
              <Route path="/videos/edit/:id" element={<VideoForm />} />
              <Route path="/videos/:id" element={<VideoDetails />} />
              
              <Route path="/trip-gps/filter" element={<TripGps />} />
              <Route path="/trip-gps/add" element={<TripGpsForm />} />
              <Route path="/trip-gps/edit/:id" element={<TripGpsForm />} />
              <Route path="/trip-gps/:id" element={<TripGpsDetails />} />

              <Route path="/statistics" element={<Statistics />} />
            </Route>
          </Route>
        </Routes>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;